export default __webpack_public_path__ + "static/media/manage_providers.623f78a9.svg";